import React from 'react';
import './App.css';
import './assets/css/common.css';
import AppRoutes from './routes/Routes';

const App = () => {
  return (
    <div className="App">
      <AppRoutes/>
    </div>
  );
}

export default App;
